export default __webpack_public_path__ + "static/media/404.a6debfe2.jpg";